import { Reveal } from "@/components/motion/Reveal";
import { Rich } from "./Rich";

// Spec-sheet titles carry no closing full stop.
export const noStop = (t) => (typeof t === "string" ? t.replace(/\.$/, "") : t);

// Crosshair + optional index + mono label, then a heavy grotesk title and optional lead. Left-aligned.
export const SectionHeader = ({ eyebrow, index, title, body, note, className = "", testId }) => (
  <Reveal className={`max-w-3xl ${className}`} data-testid={testId}>
    {eyebrow && (
      <p className="eyebrow mb-6 flex items-center gap-3">
        <span className="cross" />
        {index && <span className="text-muted">{index} /</span>}
        <span>{eyebrow}</span>
      </p>
    )}
    <h2 className="h-section">
      <Rich text={noStop(title)} />
    </h2>
    {body && (
      <p className="lead mt-6 max-w-2xl">
        <Rich text={body} />
      </p>
    )}
    {note && (
      <p className="mt-5 text-sm">
        <Rich text={note} />
      </p>
    )}
  </Reveal>
);
